let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kWMBF")).then(() => parcelRequire('6TwJU'));